<template>
  <div class="referred">
    <v-btn color="primary" style="border-radius: 0px;position: fixed;margin-top: 2px;width: 100%" class="enter-btn"
           v-if="$route.params.rec_id==0"
           v-on:click="dialog_model=true">{{ $t('addNewProduct') }}
    </v-btn>
    <v-card-text>
      <div style="margin-top: 50px">
        <div class="req-list">
          <div class="req-card" v-for="(item,index) in list" :key="item.Id">
            <div>

              <div class="flex-no-wrap justify-space-between">
                <div @click="delete_dialog(index)">
                  <div
                    class="req-name"
                    v-text="item.ProductName"
                  ></div>

                  <span class="req-code">
                    <span class="bold">
                    {{ item.Qty }} {{ $t('numbers') }}
                    </span>
                  </span>

                  <div>

                    <div class="status">{{item.StatusName}}</div>

                  </div>
                </div>

              </div>

            </div>

          </div>

        </div>
      </div>

    </v-card-text>
    <v-btn v-if="$route.params.rec_id == 0 && list.length" color="primary" style="border-radius: 0px;"
           class="enter-btn footer_btn" v-on:click="add_factor()">{{ $t('addNewRequest') }}
    </v-btn>

    <v-row justify="center">
      <v-dialog
        v-model="dialog_model"
        max-width="290"
        fullscreen
        hide-overlay
      >

        <v-card class="category-modal">
          <v-card-title class="headline">{{ $t('addProduct') }}</v-card-title>
          <v-card-text>
            <v-row>
              <v-row>
                <v-col class="p-1">

                  <treeselect
                    :multiple="false"
                    :load-options="load_models"
                    :normalizer="normalizer_models"
                    :async="true"

                    :placeholder="$t('searchProduct')"
                    v-model="auto_complete_model"
                  />
                  {{model_txt}}
                </v-col>
              </v-row>

              <v-row>

                <v-col cols="4">
                  <v-text-field
                    :placeholder="$t('count')"
                    type="number"
                    v-model="product_count"/>
                </v-col>

              </v-row>

            </v-row>
          </v-card-text>
          <v-card-actions class="">
            <v-spacer></v-spacer>

            <v-btn
              class="cancle-btn"
              text
              @click="dialog_model = false"
            >{{ $t('cancel') }}
            </v-btn>
            <v-btn

              class="accept-btn"
              text
              @click="goToDetail()"
            >{{ $t('ok') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="delete_dialog_modal"
        persistent
        max-width="290"
      >

        <v-card>
          <v-card-title class="headline">{{ $t('deleteProduct') }}</v-card-title>
          <v-card-text>{{ $t('sureToDeleteProduct') }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click="delete_dialog_modal = false"
            >{{ $t('no') }}
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              @click="delete_dialog_modal = false,list.splice(status_form,1)"
            >{{ $t('yes') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>

</template>
<script>
  import Treeselect, {ASYNC_SEARCH} from '@riophae/vue-treeselect'
  // import the styles
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

  import axios from 'axios'
  import Vue from 'vue'

  import {bus} from '../../main'

  const simulateAsyncOperation = fn => {
    setTimeout(fn, 200)
  }
  export default {
    props: [
      'passing_data'
    ],
    data() {
      return {
        auto_complete_model: null,
        search_entries: [],
        model_txt: '',

        delete_dialog_modal: false,
        status_form: 0,
        dialog_model: false,
        product_count: '',
        product_items: [],

        branch_id: 0,
        list: [],
        errors: [],
        selected_post: 0,
        selected_branch: 0,
        // request_items: [],
        // last_request_items: [],
        show_loading: false,
        no_info: true,
        page: 0,
        normalizer_models(node) {
          return {
            id: node.ProductId,
            label: node.ProductName,
          }
        },
        first: true,
      }
    },
    computed: {},
    components: {Treeselect},
    watch: {
      auto_complete_model() {
        for (var i = 0; i < this.search_entries.length; i++) {
          if (this.search_entries[i].ProductId == this.auto_complete_model) {
            this.model_txt = this.search_entries[i].ProductName
          }
        }
      },
    },
    mounted() {
      if (this.$route.params.rec_id != 0) {
        this.get_factors()
      }
      this.get_branch_permission()

      this.selected_post = parseInt(localStorage.getItem('selected_post'))
    },

    methods: {
      delete_dialog(index) {
        if (this.$route.params.rec_id == 0) {
          this.delete_dialog_modal = true
          this.status_form = index
        }
      },
      load_models({action, searchQuery, callback}) {
        this.model_txt = searchQuery
        this.auto_complete_model = null
        var self = this
        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options

            var passing_data = JSON.parse(localStorage.getItem('request_data'))

            const send_data = {
              MainProductId: 0,
              TxtSearch: searchQuery,
            }
            this.axios.post('/GetProductLowInfosByKeword', send_data, {})
              .then(response => {
                self.search_entries = response.data.products
                options = response.data.products
                callback(null, options)
                // this.$router.push({ path: "/post-login", params: {} });
              }).catch(e => {
              this.errors.push(e)
            })

            //
            // axios.post('/api/admin/product_search-tags', {
            //   search: searchQuery,
            //
            // }).then(function (response) {
            //   options = response.data;
            //   callback(null, options);
            //   // localStorage.setItem("api_token", response.data.access_token);
            //   // self.$router.push({ path: 'notes' });
            // })
            //   .catch(function (error) {
            //     self.message = 'Incorrect E-mail or password';
            //     self.showMessage = true;
            //     console.log(error);
            //   });

            //  const options = this.get_keywords(searchQuery);
            // const options = [1, 2, 3, 4, 5].map(i => ({
            //     id: `${searchQuery}-${i}`,
            //     name: `${searchQuery}-${i}`,
            // }))
          })
        }
      },

      goToDetail() {
        if (this.auto_complete_model != null && this.product_count != 0 && this.product_count != '') {
          this.list.push({
            ProductId: this.auto_complete_model,
            Qty: this.product_count,
            ProductName: this.model_txt
          })
          this.dialog_model = false
          this.auto_complete_model = null
          this.product_count = ''
        }
      },
      get_factors() {
        // this.request_items = [];
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          MasterId: this.$route.params.rec_id,
        }

        console.log('pre request called')
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetGoodsProductsByMasterId', send_data, {})
          .then(response => {
            self.last_request_items = []
            if (response.data.error == 0) {
              self.list = response.data.items
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_branch_permission() {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var party_id = localStorage.getItem('party_id')

        const send_data = {
          UserId: user_id,
          Role: 'BranchDefinition',
          PartyId: party_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/ZkGetUserPermission', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              this.branch_id = response.data.UserBranchId
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },

      add_factor() {
        // this.request_items = [];
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId

        const send_data = {
          SourceBranchId: this.branch_id,
          DestBranchId: 0,
          UserId: user_id,
          CostCenterId: this.$route.params.cost_id,
          Products: this.list,
        }

        console.log('pre request called')
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/AddGoodsReq', send_data, {})
          .then(response => {
            self.last_request_items = []
            if (response.data.error == 0) {
              bus.$emit('show_toast', [1500, response.data.msg])
              self.$router.go(-1)
            } else {
              bus.$emit('show_toast', [1500, response.data.msg])
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
    }
  }
</script>
<style>
  .v-application .headline {
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 2rem;
    letter-spacing: normal !important;
    font-family: "IRANSans" !important;
  }
</style>
